import { userSettingsModel } from 'APP/model/model';

export async function terminateSessionsOld(deviceIds: string[]): Promise<string[] | null> {
  try {
    const response = await userSettingsModel.terminateDevices({
      deviceIds,
    });

    return response;

    return [];
  } catch {
    return null;
  }
}
